import { AutoSaveList } from '../../../../../../common';
import { EMPTY_MEDICAL_DIAGNOSIS_VALUES } from '../constants';
import { MEDICAL_DIAGNOSIS_SCHEMA } from '../validationSchema';
import {
  getMedicalDiagnosisDeleteMessage,
  getMedicalDiagnosisLabel,
  mapMedicalDiagnosisRowToValues,
  toMedicalDiagnosisFieldPayload,
} from '../utils';
import { useIntakeMedicalDiagnoses } from '../hooks';
import DiagnosisFields from './DiagnosisFields';

import type {
  IIntakeMedicalDiagnosis,
  IntakeMedicalDiagnosisPayload,
} from '../../../../../../../store/questionnaires/intake';
import type { MedicalDiagnosisFormValues } from '../types';
import type { AdditionalDiagnosisListProps } from './types';

export default function AdditionalDiagnosisList({ disabled }: AdditionalDiagnosisListProps) {
  const { diagnoses, isSaving, create, update, remove } = useIntakeMedicalDiagnoses();

  return (
    <AutoSaveList<
      MedicalDiagnosisFormValues,
      IIntakeMedicalDiagnosis,
      IntakeMedicalDiagnosisPayload
    >
      addButtonLabel="Add diagnosis"
      disabled={disabled}
      emptyValues={EMPTY_MEDICAL_DIAGNOSIS_VALUES}
      entries={diagnoses}
      getDeleteConfirm={(row) => ({
        title: 'Confirm diagnosis deletion?',
        message: getMedicalDiagnosisDeleteMessage(row),
      })}
      getRowKey={(row) => row.id}
      getRowLabel={getMedicalDiagnosisLabel}
      isSaving={isSaving}
      mapRowToValues={mapMedicalDiagnosisRowToValues}
      newEntryLabel="New diagnosis"
      onCreate={create}
      onDelete={remove}
      onUpdate={update}
      renderFields={({ formik, disabled: isDisabled, readOnly, saveField }) => (
        <DiagnosisFields
          disabled={isDisabled}
          formik={formik}
          readOnly={readOnly}
          saveField={saveField}
        />
      )}
      toFieldPayload={toMedicalDiagnosisFieldPayload}
      validationSchema={MEDICAL_DIAGNOSIS_SCHEMA}
    />
  );
}
